import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appBreadcrumbDef]',
})
export class BreadcrumbDefDirective {
  public readonly templateRef = inject(TemplateRef);
}
